import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.showWarningsWarning}}
  <div class="alert alert-info">{{html-safe
      (i18n "admin.user.warnings_list_warning")
    }}</div>
{{/if}}

<UserNav::MessagesSecondaryNav>
  <DNavigationItem
    @route="userPrivateMessages.user.index"
    @ariaCurrentContext="subNav"
    class="user-nav__messages-latest"
  >
    {{d-icon "envelope"}}
    <span>{{i18n "categories.latest"}}</span>
  </DNavigationItem>

  <DNavigationItem
    @route="userPrivateMessages.user.sent"
    @ariaCurrentContext="subNav"
    class="user-nav__messages-sent"
  >
    {{d-icon "reply"}}
    <span>{{i18n "user.messages.sent"}}</span>
  </DNavigationItem>

  {{#if this.viewingSelf}}
    <DNavigationItem
      @route="userPrivateMessages.user.new"
      @ariaCurrentContext="subNav"
      class="user-nav__messages-new"
    >
      {{d-icon "exclamation-circle"}}
      <span>{{this.newLinkText}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="userPrivateMessages.user.unread"
      @ariaCurrentContext="subNav"
      class="user-nav__messages-unread"
    >
      {{d-icon "plus-circle"}}
      <span>{{this.unreadLinkText}}</span>
    </DNavigationItem>

  {{/if}}

  <DNavigationItem
    @route="userPrivateMessages.user.archive"
    @ariaCurrentContext="subNav"
    class="user-nav__messages-archive"
  >
    {{d-icon "archive"}}
    <span>{{i18n "user.messages.archive"}}</span>
  </DNavigationItem>

</UserNav::MessagesSecondaryNav>

{{outlet}}
*/
{
  "id": "4e3/aUqC",
  "block": "[[[41,[30,0,[\"showWarningsWarning\"]],[[[1,\"  \"],[10,0],[14,0,\"alert alert-info\"],[12],[1,[28,[35,1],[[28,[37,2],[\"admin.user.warnings_list_warning\"],null]],null]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[8,[39,3],null,null,[[\"default\"],[[[[1,\"\\n  \"],[8,[39,4],[[24,0,\"user-nav__messages-latest\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.user.index\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,5],[\"envelope\"],null]],[1,\"\\n    \"],[10,1],[12],[1,[28,[35,2],[\"categories.latest\"],null]],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n  \"],[8,[39,4],[[24,0,\"user-nav__messages-sent\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.user.sent\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,5],[\"reply\"],null]],[1,\"\\n    \"],[10,1],[12],[1,[28,[35,2],[\"user.messages.sent\"],null]],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"viewingSelf\"]],[[[1,\"    \"],[8,[39,4],[[24,0,\"user-nav__messages-new\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.user.new\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"exclamation-circle\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[30,0,[\"newLinkText\"]]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,4],[[24,0,\"user-nav__messages-unread\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.user.unread\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"plus-circle\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[30,0,[\"unreadLinkText\"]]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,4],[[24,0,\"user-nav__messages-archive\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.user.archive\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,5],[\"archive\"],null]],[1,\"\\n    \"],[10,1],[12],[1,[28,[35,2],[\"user.messages.archive\"],null]],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"]],[]]]]],[1,\"\\n\\n\"],[46,[28,[37,7],null,null],null,null,null]],[],false,[\"if\",\"html-safe\",\"i18n\",\"user-nav/messages-secondary-nav\",\"d-navigation-item\",\"d-icon\",\"component\",\"-outlet\"]]",
  "moduleName": "discourse/templates/user-private-messages-user.hbs",
  "isStrictMode": false
});